import { cleanScript, loadScript } from "@obg/ngx.global";
import { Observable, of } from "rxjs";

import { FraudPreventionConfigService } from "./fraud-prevention.config";
import { FraudPreventionProvider } from "./fraud-prevention.model";
import { FraudPreventionService } from "./fraud-prevention.service";

export class IovationFraudPreventionService extends FraudPreventionService {
	constructor(private config: FraudPreventionConfigService) {
		super();
	}

	loadScript() {
		loadScript({
			src: this.config.getIovationUrl(),
			id: `fraud-prevention-${FraudPreventionProvider.Iovation}`,
		});
	}

	getCustomerFraudToken$(): Observable<undefined> {
		return of(undefined);
	}

	unloadScript() {
		cleanScript(`fraud-prevention-${FraudPreventionProvider.Iovation}`);
	}

	init() {
		// no-op
	}
}
